export const isObject = (value) => {
    return typeof value === "object" && !Array.isArray(value) && value !== null;
};
export const constructEventsWithNamespace = (topic, parents = []) => {
    return Object.entries(topic).reduce((acc, [key, value]) => {
        acc[key] = isObject(value)
            ? constructEventsWithNamespace(value, [...parents, key])
            : [...parents, value].join(".");
        return acc;
    }, {});
};
//# sourceMappingURL=event-bus-helpers.js.map